import { useCallback, useState } from 'react';
import type React from 'react';
const SWIPE_THRESHOLD = 146;

export const useSwipeGesture = (isMobileDevice: boolean) => {
  const [swipedItemId, setSwipedItemId] = useState<string | null>(null);
  const [touchStartX, setTouchStartX] = useState<number | null>(null);
  const [touchEndX, setTouchEndX] = useState<number | null>(null);
  const [deletingId, setDeletingId] = useState<string | null>(null);

  const resetSwipe = useCallback(() => {
    setSwipedItemId(null);
    setTouchStartX(null);
    setTouchEndX(null);
  }, []);

  const handleTouchStart = useCallback(
    (e: React.TouchEvent, itemId: string) => {
      if (!isMobileDevice) return;

      if (swipedItemId && swipedItemId !== itemId) {
        resetSwipe();
      }
      setTouchStartX(e.touches[0].clientX);
      setSwipedItemId(itemId);
    },
    [isMobileDevice, swipedItemId, resetSwipe]
  );

  const handleTouchMove = useCallback(
    (e: React.TouchEvent) => {
      if (!isMobileDevice || touchStartX == null || !swipedItemId) return;
      const currentX = e.touches[0].clientX;
      setTouchEndX(currentX);
    },
    [isMobileDevice, touchStartX, swipedItemId]
  );

  const handleTouchEnd = useCallback(
    (e: React.TouchEvent) => {
      if (!isMobileDevice || touchStartX == null || touchEndX == null || !swipedItemId) return;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) < SWIPE_THRESHOLD) {
        resetSwipe();
      } else if (diff < 0) {
        resetSwipe();
      }
    },
    [isMobileDevice, touchStartX, touchEndX, resetSwipe, swipedItemId]
  );

  return {
    swipedItemId,
    touchStartX,
    touchEndX,
    deletingId,
    handleTouchStart,
    handleTouchMove,
    handleTouchEnd,
    resetSwipe,
    setDeletingId
  } as const;
};

export default useSwipeGesture;
